import type React from "react";

export interface BreakdownBar {
  /** Row label shown on the left (e.g. a status or team name). */
  label: string;
  /** Pre-formatted value shown on the right (e.g. "12" or "87.5%"). */
  display: string;
  /** Resolved bar + dot colour. */
  color: string;
  /** Bar width as a percentage, 0–100. */
  pct: number;
}

/**
 * A list of horizontal proportion bars — each a labelled row with a colour dot,
 * a value, and a fill bar. Shared by the Emergency status, Check-in completion,
 * and Team Alert status breakdowns so they stay visually identical.
 */
export function BreakdownBars({ bars }: { bars: BreakdownBar[] }): React.JSX.Element {
  return (
    <div className="space-y-3.5">
      {bars.map((bar, i) => (
        <div key={i}>
          <div className="flex items-center justify-between mb-1">
            <span className="flex items-center gap-2 text-sm font-head text-foreground">
              <span
                className="inline-block h-2.5 w-2.5 rounded-full shrink-0"
                style={{ background: bar.color }}
                aria-hidden="true"
              />
              {bar.label}
            </span>
            <span className="num text-sm font-semibold text-foreground">{bar.display}</span>
          </div>
          <div className="h-2 rounded-full bg-muted overflow-hidden">
            <div
              className="h-full rounded-full transition-all"
              style={{ width: `${Math.min(bar.pct, 100).toFixed(2)}%`, background: bar.color }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
